
export const environment = {
  production: false,
  apiUrl: 'http://localhost:3013/api'
  // apiUrl: 'https://fermaco.mercosys.com.py/api'
};
